  // Cloudinary configuration for frontend
  // Cloud name MUST be provided via REACT_APP_CLOUDINARY_CLOUD_NAME env var.
  // No hardcoded fallback — missing env var will surface as a build-time error
  // rather than silently shipping credentials in the bundle.
  const cloudinaryConfig = {
    cloudName: process.env.REACT_APP_CLOUDINARY_CLOUD_NAME,
    uploadPreset: process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || 'oli-gardens-blog'
  };

  export default cloudinaryConfig;

  // Helper function to get Cloudinary upload URL
  export const getCloudinaryUploadUrl = () => {
    if (!cloudinaryConfig.cloudName) {
      throw new Error('REACT_APP_CLOUDINARY_CLOUD_NAME is not set');
    }
    return `https://api.cloudinary.com/v1_1/${cloudinaryConfig.cloudName}/image/upload`;
  };

  // Helper function to get Cloudinary image URL with optimizations
  export const getCloudinaryImageUrl = (publicId, options = {}) => {
    if (!cloudinaryConfig.cloudName) return publicId;
    const { width, height, quality = 'auto', format = 'auto' } = options;
    let url = `https://res.cloudinary.com/${cloudinaryConfig.cloudName}/image/upload`;

    if (width || height || quality !== 'auto' || format !== 'auto') {
      const transformations = [];
      if (width) transformations.push(`w_${width}`);
      if (height) transformations.push(`h_${height}`);
      if (quality !== 'auto') transformations.push(`q_${quality}`);
      if (format !== 'auto') transformations.push(`f_${format}`);

      url += `/${transformations.join(',')}`;
    }

    url += `/${publicId}`;
    return url;
  };

  // Helper function to optimize blog images for different use cases.
  // Inserts resize transformations directly into the stored URL so the original
  // cloud name is always preserved (avoids mismatches with REACT_APP_CLOUDINARY_CLOUD_NAME).
  export const getOptimizedBlogImage = (imageUrl, size = 'medium') => {
    if (!imageUrl || !imageUrl.includes('cloudinary.com')) {
      return imageUrl;
    }

    const sizeConfig = {
      small:     { width: 300,  height: 200 },
      medium:    { width: 600,  height: 400 },
      large:     { width: 1200, height: 800 },
      thumbnail: { width: 150,  height: 150 },
    };

    const { width, height } = sizeConfig[size] || sizeConfig.medium;
    const transform = `w_${width},h_${height},c_fill,f_auto,q_auto`;

    // Insert the transformation string right after /upload/ in the existing URL.
    // If the URL already has transformations there, this still results in a valid
    // chained-transformation URL that Cloudinary handles correctly.
    return imageUrl.replace('/upload/', `/upload/${transform}/`);
  };
